import {PRISMAX_DATA_PIPELINE_URL} from '../configs/config';
import {getApiErrorMessage} from '../utils/authErrors';

function buildHeaders(token, includeJson = true) {
    const headers = {};
    if (includeJson) headers['Content-Type'] = 'application/json';
    if (token) headers.Authorization = `Bearer ${token}`;
    return headers;
}

export function buildDatasetStatsParams(query = {}) {
    const params = new URLSearchParams();
    params.set('task', query.task || 'All tasks');
    params.set('robot_type', query.robotType || 'all');
    params.set('operator_id', query.operatorId || '');
    params.set('time_span', query.timeSpan || 'all');
    params.set('hide_task_12', query.hideTask12 === false ? 'false' : 'true');
    if (query.timeSpan === 'custom') {
        if (query.dateFrom) params.set('date_from', query.dateFrom);
        if (query.dateTo) params.set('date_to', query.dateTo);
    }
    return params;
}

export async function fetchDatasetStatsAdmin({token, query, signal} = {}) {
    const params = buildDatasetStatsParams(query);
    const response = await fetch(
        `${PRISMAX_DATA_PIPELINE_URL}/data/admin/dataset-stats?${params.toString()}`,
        {
            headers: buildHeaders(token, false),
            signal,
        },
    );
    const payload = await response.json().catch(() => ({}));
    if (!response.ok || payload?.success === false) {
        throw new Error(getApiErrorMessage(payload, 'Failed to load dataset stats.'));
    }
    return payload?.data || payload;
}

export async function downloadDatasetStatsCsvAdmin({token, query, signal} = {}) {
    const params = buildDatasetStatsParams(query);
    const response = await fetch(
        `${PRISMAX_DATA_PIPELINE_URL}/data/admin/dataset-stats/export?${params.toString()}`,
        {
            headers: buildHeaders(token, false),
            signal,
        },
    );
    if (!response.ok) {
        const payload = await response.json().catch(() => ({}));
        throw new Error(getApiErrorMessage(payload, 'Failed to download dataset stats CSV.'));
    }
    return response;
}
